import { PremiumCartApiAggregations } from './premium-cart-aggregations.api-config';
import { combineApiConfigs } from '@wix/premium-fed-sdk/@apis-infra';
import { PremiumCartApiConfig } from '../premium-cart/premium-cart.api-config';
const PremiumCartCombineConfigs = combineApiConfigs(PremiumCartApiAggregations, PremiumCartApiConfig);
export const PremiumCartPublicApiConfig = {
  upsertLineItemToActiveCart: PremiumCartCombineConfigs.upsertLineItemToActiveCart,
  upsertLineItemsToActiveCart: PremiumCartCombineConfigs.upsertLineItemsToActiveCart,
  cancelActiveCart: PremiumCartCombineConfigs.cancelActiveCart
};
//# sourceMappingURL=premium-cart-public.api-config.js.map